import { FC } from 'react';
import { DotSpinner } from '@crono-one/design-system';

import PATH from 'crono-fe-common/constants/path';
import useSalesforceAuthCallback from 'hooks/services/salesforce/useSalesforceAuthCallback';
import {
  clearSalesforceCodeVerifier,
  readSalesforceCodeVerifier,
} from 'hooks/services/salesforce/salesforcePkce';
import { useAuth } from 'context/auth';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import useOauthCallbackCode from 'pages/connect/views/useOauthCallbackCode';
import storeOnboardingError from 'pages/connect/views/storeOnboardingError';

const SalesforceLoginHandler: FC = () => {
  const { refreshUser } = useAuth();
  const { mutate: salesforceAuthCallback } = useSalesforceAuthCallback();

  useOauthCallbackCode({
    provider: 'Salesforce',
    exchangeCode: salesforceAuthCallback,
    buildVariables: (code) => ({
      code,
      codeVerifier: readSalesforceCodeVerifier() ?? undefined,
    }),
    missingCodePath: PATH.CONNECT,
    successPath: PATH.SETTINGS.INTEGRATIONS.MAIN,
    errorPath: PATH.CONNECT,
    cleanUp: clearSalesforceCodeVerifier,
    onSuccess: refreshUser,
    onError: (error) => storeOnboardingError(error, IntegrationType.SALESFORCE),
  });

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default SalesforceLoginHandler;
